import React from 'react';
import { Container } from '@mui/material';
import {
    CurrentCollectionProvider,
    DetailOrderHeader,
    DossierRoutingProvider,
    dossiersBasePath,
} from '@europrocurement/l2d-modules';
import { useParams } from 'react-router';
import { OrderBody } from '../../components';
import { ordersBasePath } from '../../constants';

const OrderDetail: React.FunctionComponent = function () {
    const { idOrder } = useParams();
    if (!idOrder) {
        console.log(`Commande non trouvée paramètres url:  ${idOrder}`);
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
    }

    return (
        <DossierRoutingProvider
            orderBasePath={ordersBasePath}
            dossierBasePath={dossiersBasePath}
        >
            <CurrentCollectionProvider
                autoload
                idCollection={idOrder}
            >
                <Container maxWidth="lg">
                    <DetailOrderHeader />
                    <OrderBody />
                </Container>
            </CurrentCollectionProvider>
        </DossierRoutingProvider>
    );
};

export default OrderDetail;
